import { environment } from '../../../../environments/environment';

export function isLisaApiRequest(url: string): boolean {
  const apiBase = environment.apiUrl.replace(/\/$/, '');
  if (!apiBase) {
    return url.includes('/api/');
  }
  return url.startsWith(apiBase);
}
